import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { history } from '../../helpers';
import './menu.css';

interface IItem {
  id: number | string;
  go: any;
  icon: ReactNode | JSX.Element;
  label: string;
}

export interface IMenuProps {
  children?: ReactNode;
  data: IItem[];
  action: (item: IItem) => void;
  cy: string;
}

export const Menu: React.FC<IMenuProps> = ({
  children,
  data,
  action = () => null,
  cy = '',
}) => {
  const location = useLocation();
  const isActive = (address: any) => location.pathname === address;
  const actionMenu = (e: any) => {
    if (e.url) {
      window.open(e.url, '_blank');
    }
    if (e.go) {
      history.push(e.go);
    }
    action(e);
  };

  return (
    <div className="menu" data-cy={`Menu${cy}`}>
      {data && data.length
        ? data.map((item: any) => {
            return (
              <button
                key={item.id}
                className={isActive(item.go) ? 'active' : ''}
                onClick={() => actionMenu(item)}
                data-cy={`MenuList${item.id}Optionclick${cy}`}
              >
                <span data-cy={`MenuItem${cy}IconOrLabel`}>
                  {item.icon ? item.icon : item.label}
                </span>
              </button>
            );
          })
        : null}

      {children}
    </div>
  );
};
